<div class="mb-3 irembogov-custom-label-value-repeater">
  <legend *ngIf="props.label">{{ props.label }}</legend>
  <p *ngIf="props.description">{{ props.description }}</p>

  <div
    *ngFor="let dropDownField of field.fieldGroup; let i = index"
    class="d-flex align-items-center border-bottom mb-2 pb-3 custom-label-value-repeater-extra-fields">
    <formly-field
      class="me-auto repeater-group label-value-repeater-extra-fields"
      [field]="dropDownField"></formly-field>
    <button
      class="btn btn-danger ms-2 repeater-add-button"
      type="button"
      (click)="remove(i)">
      <i class="fa-solid fa-trash-can"></i>
    </button>
  </div>
  <div class="my-1">
    <button
      class="btn btn-primary btn-sm ms-2"
      type="button"
      (click)="add(field.fieldGroup?.length || 0)">
      <i class="fa-solid fa-plus"></i> {{ props['addText'] }}
    </button>
  </div>
</div>
